import JourFerieDetailController from './jour.ferie.detail.controller';

export default {
    template: require('./jour.ferie.detail.html'),
    controller: JourFerieDetailController
};
